// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".food-menu .sidemenu .menu-item[data-v-1e1dab93]{width:100px;max-width:unset;min-width:unset}.cat-image[data-v-1e1dab93]{height:395px;-o-object-fit:cover;object-fit:cover;-o-object-position:left top;object-position:left top}", ""]);
// Exports
module.exports = exports;
